module.exports = __webpack_public_path__ + "static/img/pay_succ_joychat.2a247d95.png";